import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { OrderItem } from '../../../subcomponents/order-item/order-item';
import { OrderCartContextInstance } from '../types/context';
import { OrderCartSectionDivider } from './section-divider';
const b = bemClassBuilder('v-order-cart-item-list');
export const OrderCartItemList = observer(props => {
    const { orderItems, disableRemoveButton, onRemoveItem } = props;
    const { displayText, config, events, assets, cdnOptions } = useContext(OrderCartContextInstance);
    if (isEmptyArray(orderItems))
        return null;
    return (_jsxs("ul", Object.assign({ className: b.block() }, { children: [_jsx(OrderCartSectionDivider, { title: displayText.itemsSectionTitle, actionButtonLabel: displayText.itemsSectionActionButtonLabel, showActionButton: config.items.showActionButton, onActionButtonClicked: events.onItemsActionButtonClicked }), orderItems.map((orderItem) => {
                const removeButton = {
                    iconName: assets.removeItemButtonIconName,
                    removeItemButtonLabel: displayText.removeItemButtonLabel,
                    disabled: disableRemoveButton,
                    onClick: () => onRemoveItem(orderItem)
                };
                return (_jsx(OrderItem, { item: orderItem, modifierDetailsTemplate: displayText.itemModifierDetails, showImage: config.items.showImage, removeButton: config.items.showRemoveButton ? removeButton : undefined, imageCdnOptions: cdnOptions.itemImage }, orderItem.id));
            })] })));
});
OrderCartItemList.displayName = 'OrderCartItemList';
